import useData from "./useData";

export const CUSTOMIZATION_TYPE = {
	CHECKOUT: "checkout",
};

export const CUSTOMIZATION_DETAIL = {
	[CUSTOMIZATION_TYPE.CHECKOUT]: {
		WIDGET_HEADING: "widget_heading",
		WIDGET_SUBHEADING: "widget_subheading",
		WIDGET_BOTTOM_SLOT_HEADING: "widget_bottom_slot_heading",
		WIDGET_UNCLAIMED_PROMO_CTA_TEXT: "widget_unclaimed_promo_cta_text",
		WIDGET_CLAIMED_PROMO_CTA_TEXT: "widget_claimed_promo_cta_text",
		WIDGET_UNCLAIMED_NO_PROMO_CTA_TEXT:
			"widget_unclaimed_no_promo_cta_text",
		WIDGET_CLAIMED_NO_PROMO_CTA_TEXT: "widget_claimed_no_promo_cta_text",
		WIDGET_NAV_FORWARD_CTA_TEXT: "widget_nav_forward_cta_text",
		WIDGET_NAV_BACKWARD_CTA_TEXT: "widget_nav_backward_cta_text",
	},
};

const useCustomization = ({ type = CUSTOMIZATION_TYPE.CHECKOUT } = {}) => {
	const data = useData();

	const customization = data?.publisher_customization?.[type] || null;

	const hasCustomization = (detail = "") => {
		if (!customization || typeof customization !== "object" || !detail)
			return false;
		return !!customization[detail];
	};

	const getCustomization = (detail = "") => {
		if (!hasCustomization(detail)) return null;
		return customization[detail];
	};

	const applyCustomizationOrFallback = (detail = "", fallback = null) => {
		if (!hasCustomization(detail)) return fallback;
		return getCustomization(detail);
	};

	return {
		customization,
		hasCustomization,
		getCustomization,
		applyCustomizationOrFallback,
	};
};

export default useCustomization;
